import { useEffect, useState } from 'react';

const DOUBLE_CLICK_DEBOUNCE_IN_MS = 250;

export const useElementClick = (
  clickCallback: () => void,
  doubleClickHandler?: () => void,
): () => void => {
  const [clickCount, setClickCount] = useState(0);

  useEffect(() => {
    let timer: NodeJS.Timeout;

    if (clickCount === 1) {
      if (!doubleClickHandler) {
        clickCallback();
        setClickCount(0);
      } else {
        timer = setTimeout(() => {
          if (clickCount === 1) {
            clickCallback();
          }
          setClickCount(0);
        }, DOUBLE_CLICK_DEBOUNCE_IN_MS);
      }
    } else if (clickCount === 2) {
      doubleClickHandler?.();
      setClickCount(0);
    }

    return () => clearTimeout(timer);
  }, [clickCount, clickCallback, doubleClickHandler]);

  return () => {
    setClickCount((prevCount) => prevCount + 1);
  };
};
